module.exports = __webpack_public_path__ + "static/img/evaluate.b910898.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/lesson-evaluate/evaluate.png
// module id = ynH6
// module chunks = 1